var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-block p-relative overflow-hidden container",style:({
    padding: _vm.blockPadding,
    height: _vm.height,
    minHeight: _vm.height,
    minHeight: ("calc(" + _vm.height + " + env(safe-area-inset-top))")
  })},[_c('location-map',{ref:"location-map",attrs:{"lat":_vm.map.lat,"lng":_vm.map.lng,"height":_vm.height,"interactive":!_vm.isBuilderContext()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }